import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Grid, Card, TextField, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import DateSelect from '../../../components/DateSelect';
import Button from '../../../components/Button';
import PressEditModal from '../../../components/PressEditModal';

import * as api from '../../../services/api/admin';

function PressContent(props) {
  const {
    classes: { input, cards, contentCard, card },
  } = props;

  const [pressContents, setPressContents] = useState([]);
  const [title, setTitle] = useState('');
  const [author, setAuthor] = useState('');
  const [headline, setHeadline] = useState('');
  const [category, setCategory] = useState([]);
  const [date, setDate] = useState('');
  const [linkToImg, setLinkToImg] = useState('');
  const [imgDescription, setImgDescription] = useState('');
  const [content, setContent] = useState('');
  const [externalUrl, setExternalUrl] = useState('');
  const [openEditModal, setOpenEditModal] = useState('');

  useEffect(() => {
    (async () => {
      const contents = await api.fetchPressContents();
      setPressContents(contents);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const contents = await api.fetchPressContents();
      setPressContents(contents);
    })();
  }, [openEditModal]);

  const createPressContent = async item => {
    const contentDetails = {
      title: item.title,
      author: item.author,
      headline: item.headline,
      category: item.category,
      date: item.date,
      linkToImg: item.linkToImg,
      content: item.content,
      imgDescription: item.imgDescription,
      externalUrl: item.externalUrl,
    };
    await api.createPressContent(contentDetails);
    const contents = await api.fetchPressContents();
    setPressContents(contents);
    setTitle('');
    setAuthor('');
    setHeadline('');
    setCategory('');
    setDate('');
    setLinkToImg('');
    setContent('');
    setImgDescription('');
    setExternalUrl('')
  };

  const onDelete = async id => {
    try {
      await api.deletePressContent(id);
    } catch (err) {
      console.log(err);
    } finally {
      const contents = await api.fetchPressContents();
      setPressContents(contents);
      setOpenEditModal('');
    }
  };
  return (
    <>
      <Grid container alignItems="center">
        <Grid item xs={11}>
          <h2>Insert New Press Content</h2>
        </Grid>
        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="title"
          value={title}
          className={input}
          onChange={event => {
            setTitle(event.target.value);
          }}
          InputProps={{ whiteSpace: 'pre-line' }}
          helperText="Title"
        />

        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="author"
          value={author}
          className={input}
          onChange={event => {
            setAuthor(event.target.value);
          }}
          InputProps={{ whiteSpace: 'pre-line' }}
          helperText="Author"
        />

        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="headline"
          value={headline}
          className={input}
          onChange={event => {
            setHeadline(event.target.value);
          }}
          InputProps={{ whiteSpace: 'pre-line' }}
          multiline
          rows="2"
          helperText="Headline"
        />
        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="category"
          value={category}
          className={input}
          onChange={event => {
            setCategory(event.target.value);
          }}
          InputProps={{ whiteSpace: 'pre-line' }}
          helperText="Category"
        />

        <DateSelect
          label="Date Published"
          disableFuture
          fullWidth
          format="MM/DD/YYYY"
          placeholder="Date originally publihed MM/DD/YYYY ex. 01/01/2001"
          variant="outlined"
          value={new Date(date)}
          onChange={date => {
            setDate(moment(date).format('MM/DD/YYYY'));
          }}
        />
        <TextField
          variant="outlined"
          fullWidth
          name="linkToImg"
          value={linkToImg}
          className={input}
          onChange={event => {
            setLinkToImg(event.target.value);
          }}
          multiline
          rows="1"
          helperText="Image URL goes here. "
        />
        <TextField
          variant="outlined"
          fullWidth
          name="imgDescription"
          value={imgDescription}
          className={input}
          onChange={event => {
            setImgDescription(event.target.value);
          }}
          multiline
          rows="1"
          helperText="Write a short description for the image."
        />
        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="content"
          value={content}
          className={input}
          onChange={event => {
            setContent(event.target.value);
          }}
          multiline
          InputProps={{ whiteSpace: 'pre-line' }}
          rows="4"
          helperText="Content goes here"
        />

        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="externalUrl"
          value={externalUrl}
          className={input}
          onChange={event => {
            setExternalUrl(event.target.value);
          }}
          multiline
          InputProps={{ whiteSpace: 'pre-line' }}
          rows="1"
          helperText="externalUrl goes here. Make sure you are getting the embedded link! They are often under *share*... https://www.youtube.com/embed/DwjMCtjxtTg"
        />

      </Grid>

      <Button
        onClickSuccessSnackbar="Content was sucessfully submitted."
        onClickFailSnackbar="Content could not be submitted"
        color="primary"
        variant="contained"
        onClick={() =>
          createPressContent({
            title,
            author,
            headline,
            category,
            date,
            linkToImg,
            content,
            imgDescription,
            externalUrl,
          })
        }
      >
        Submit
      </Button>
      <Grid items className={cards}>
        {pressContents
          ? pressContents
            .sort((a, b) => new Date(a.date) - new Date(b.date))
            .map(content => {
              return (
                <Card className={card}>
                  <Button onClick={() => setOpenEditModal(content.id)}>
                    Edit
                    </Button>
                  <Grid container className={contentCard}>
                    <Grid item xs={3}>
                      <img
                        src={content.linkToImg}
                        width="300"
                        height="300"
                        alt={content.imgDescription}
                      />
                    </Grid>
                    <Grid item xs={8}>
                      <Typography gutterBottom variant="h3">
                        {content.title}
                      </Typography>
                      <Typography gutterBottom>
                        Date published:{' '}
                        {moment(content.date).format('MM/DD/YYYY')}
                      </Typography>
                      <Typography>{content.headline}</Typography>
                      <Typography gutterBottom="true" variant="h6">
                        {content.content
                          ? content.content
                            .split('\n')
                            .map(paragraph => (
                              <Typography gutterBottom="true">
                                {paragraph}
                              </Typography>
                            ))
                          : ''}
                      </Typography>
                      <Typography varaiant="h6">
                        {content.imgDescription}
                      </Typography>
                    </Grid>
                  </Grid>
                </Card>
              );
            })
          : null}
      </Grid>
      <PressEditModal
        onDelete={onDelete}
        openEditModal={openEditModal}
        open={openEditModal}
        onClose={() => {
          setOpenEditModal('');
        }}
      />
    </>
  );
}

const styles = () => ({
  contentCard: {
    margin: '2em',
    padding: '1em',
    display: 'flex',
    justify: 'center',
  },
  card: {
    margin: '1em',
  },
  cards: {
    padding: '1em',
    margin: '1.5em',
  },
});

export default withStyles(styles)(PressContent);
